// SAUCES - 30 de marzo GLTF 
import './style.css'
import * as THREE from 'three'
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js'
import * as dat from 'lil-gui'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader.js'
import { SVGLoader } from 'three/addons/loaders/SVGLoader.js';
import { Raycaster } from 'three'
import gsap from 'gsap'

/**
 * MAQUETA
 */
//Menu maqueta

//const anchoMaqueta = menuMaqueta.offsetWidth 
const menuMaqueta = document.querySelector('#maqueta-menu'),
    anchoMaqueta = 0,
    
    cargando = document.getElementById('pantalla-carga'),
    barraCarga = cargando.querySelector('.loading-barra')

// Debug
const gui = new dat.GUI()
let mapaFolder = gui.addFolder('Mapa'),
    mapa_terrenosFolder = mapaFolder.addFolder('Terrenos')
   

mapaFolder.close()
// Canvas
const canvas = document.querySelector('canvas.webgl')
// Scene
const scene = new THREE.Scene()
scene.background = new THREE.Color('#aee9f3');
/**
 * Loaders
 */
const loadingManager = new THREE.LoadingManager(
    //Cargado
    () => {
        console.log('MAQUETA LISTA');
        cargando.classList.add('cargado')
        setTimeout(_ => cargando.remove(), 1200)
    },
    //En progreso
    (itemUrl, itemsLoaded, itemsTotal) => {
        const progressRatio = itemsLoaded / itemsTotal
        barraCarga.style.transform = `scaleX(${progressRatio})`
    }
)
const dracoLoader = new DRACOLoader(loadingManager),
    gltfLoader = new GLTFLoader(loadingManager),
    svgloader = new SVGLoader(loadingManager),
    cubeTextureLoader = new THREE.CubeTextureLoader(loadingManager),
    textureLoader = new THREE.TextureLoader(loadingManager)

dracoLoader.setDecoderPath('/draco/')
gltfLoader.setDRACOLoader(dracoLoader)
// Axes helper
const axesHelper = new THREE.AxesHelper(2)
//scene.add(axesHelper)
//Colores
const colores = {
    colorProyecto: '#EDE0CE',
    colorProyectoAlt: '#F5F5F5',
    contextoFillColor: '#FFFFFF',
    contextoLineColor: '#FFFFFF',
    colorVias: '#eee1cf',
    colorTransito: '#222431',
    colorAlerta: '#C1403A',
    colorArboles: '#ffffff',
    colorAndenes: '#e5c6a7',
    colorCielo: '#fffbf5',
    colorBruma: '#fffbf5',
    mascara_1: '#458376',
    mascara_2: '#C1403A',
    mascara_3: '#313c90',
    colorTerreno: '#8b9541'
}

const paletaMascaras = [colores.mascara_1, colores.mascara_2, colores.mascara_3]

//////////////////////////////////////////////TEXTURAS//////////////////////////////////////////////////////////////////////
//Texturas Carga torre 1
const text_Torre1 = textureLoader.load('texturas/TORRE 01_FL_Corona_Diffuse.webp'),
text_Torre1_cubierta = textureLoader.load('texturas/TORRE 01_PISOS Y CUARTOS CUBIERTA_FL_Corona_Diffuse.webp'),
text_Torre1_ventanas = textureLoader.load('texturas/TORRE 01_VENTANAS_FL_Corona_Diffuse.webp'),
text_Torre1_P1 = textureLoader.load('texturas/TORRE 01_P1_FL_Corona_Diffuse.webp'),
text_Torre1_BalconesMuros = textureLoader.load('texturas/TORRE 01_BALCONES_MUROS_FL_Corona_Diffuse.webp'),
text_Torre1_Balcones_Alpha = textureLoader.load('texturas/TORRE 01_BALCONES_BARANDAS_FL_Corona_Alpha.webp'),
text_Torre1_Balcones_difusse = textureLoader.load('texturas/TORRE 01_BALCONES_BARANDAS_FL_Corona_Diffuse.webp'),
//Texturas carga Torre 2
text_Torre2 = textureLoader.load('texturas/TORRE 02_FL_Corona_Diffuse.webp'),
text_Torre2_cubierta = textureLoader.load('texturas/TORRE 02_PISOS Y CUARTOS CUBIERTA_FL_Corona_Diffuse.webp'),
text_Torre2_ventanas = textureLoader.load('texturas/TORRE 02_VENTANAS_FL_Corona_Diffuse.webp'),
text_Torre2_P1 = textureLoader.load('texturas/TORRE 02_P1_FL_Corona_Diffuse.webp'),
text_Torre2_BalconesMuros = textureLoader.load('texturas/TORRE 02_BALCONES_MUROS_FL_Corona_Diffuse.webp'),
text_Torre2_Balcones_Alpha = textureLoader.load('texturas/TORRE 02_BALCONES_BARANDAS_FL_Corona_Alpha.webp'),
text_Torre2_Balcones_difusse = textureLoader.load('texturas/TORRE 02_BALCONES_BARANDAS_FL_Corona_Diffuse.webp'),
//////contexto sauces
text_contexto_carros = textureLoader.load('texturas/CARROS_FL_Corona_Diffuse.webp'),
text_contexto_cerramiento_alpha = textureLoader.load('texturas/CERRAMIENTO URBANISMO_FL_Corona_Alpha.webp'),
text_contexto_cerramiento = textureLoader.load('texturas/CERRAMIENTO URBANISMO_FL_Corona_Diffuse.webp'),
text_contexto_comunal = textureLoader.load('texturas/COMUNAL_FL_Corona_Diffuse.webp'),
text_contexto_duplicadores = textureLoader.load('texturas/DUPLICADORES_FL_Corona_Diffuse.webp'),
text_contexto_sauces = textureLoader.load('texturas/URBANISMO SAUCES_FL_Corona_Diffuse.webp'),
text_contexto_lafelicidad = textureLoader.load('texturas/URBANISMO LA FELICIDAD_FL_Corona_Diffuse.webp'),
text_contexto_vegetacion = textureLoader.load('texturas/VEGETACION LA FELICIDAD_FL_Corona_Diffuse.webp'),
////fondo/////
text_urbanismo_fondo= textureLoader.load('texturas/FondoLow.webp'),
text_disp_terreno = textureLoader.load('texturas/terreno_elevacion.jpg')

//Texturas Flip
/////torre 1
text_Torre1.flipY = false
text_Torre1_cubierta.flipY = false
text_Torre1_ventanas.flipY = false
text_Torre1_P1.flipY = false
text_Torre1_BalconesMuros.flipY = false
text_Torre1_Balcones_Alpha.flipY = false
text_Torre1_Balcones_difusse.flipY = false
////torre 2 
text_Torre2.flipY = false
text_Torre2_cubierta.flipY = false
text_Torre2_ventanas.flipY = false
text_Torre2_P1.flipY = false
text_Torre2_BalconesMuros.flipY = false
text_Torre2_Balcones_Alpha.flipY = false
text_Torre2_Balcones_difusse.flipY = false
/////contexto sauces
text_contexto_carros.flipY = false
text_contexto_cerramiento.flipY = false
text_contexto_cerramiento_alpha.flipY = false
text_contexto_comunal.flipY = false
text_contexto_duplicadores.flipY = false
text_contexto_lafelicidad.flipY = false
text_contexto_sauces.flipY = false
text_contexto_vegetacion.flipY = false
//Materiales
const mat_BarandasBalcones = new THREE.MeshStandardMaterial({
   map: text_Torre1_Balcones_difusse, transparent:true, alphaMap: text_Torre1_Balcones_Alpha,
   side:THREE.DoubleSide})
   const mat_BarandasBalcones2 = new THREE.MeshStandardMaterial({
    map: text_Torre2_Balcones_difusse, transparent:true, alphaMap: text_Torre2_Balcones_Alpha,
    side:THREE.DoubleSide})

const mat_CerramientoUrbanismo = new THREE.MeshStandardMaterial({
   map: text_contexto_cerramiento, transparent:true, alphaMap: text_contexto_cerramiento_alpha,
   side:THREE.DoubleSide})   

const mat_vecinos  = new THREE.MeshStandardMaterial({ 
    color: 0xCCCCCC, transparent:true, opacity: 0.2})

const mat_terreno = new THREE.MeshStandardMaterial({
    displacementMap: text_disp_terreno,
    displacementScale: 27,
    //wireframe: true,
    color: colores.colorTerreno,
    })

/////torre 1
const mat_Torre1  = new THREE.MeshStandardMaterial({ map: text_Torre1})
const mat_Torre1_p1  = new THREE.MeshStandardMaterial({ map: text_Torre1_P1})
const mat_Torre1_cubierta  = new THREE.MeshStandardMaterial({ map: text_Torre1_cubierta})
const mat_Torre1_ventanas  = new THREE.MeshStandardMaterial({ map: text_Torre1_ventanas})
const mat_urbanismo_fondo  = new THREE.MeshStandardMaterial({ map: text_urbanismo_fondo})
const mat_Torre1_balconesMuros  = new THREE.MeshStandardMaterial({ map: text_Torre1_BalconesMuros})
////torre 2 
const mat_Torre2  = new THREE.MeshStandardMaterial({ map: text_Torre2})
const mat_Torre2_p1  = new THREE.MeshStandardMaterial({ map: text_Torre2_P1})
const mat_Torre2_cubierta  = new THREE.MeshStandardMaterial({ map: text_Torre2_cubierta})
const mat_Torre2_ventanas  = new THREE.MeshStandardMaterial({ map: text_Torre2_ventanas})
const mat_Torre2_balconesMuros  = new THREE.MeshStandardMaterial({ map: text_Torre2_BalconesMuros})
//////contexto sauces
const  mat_contexto_carros  = new THREE.MeshStandardMaterial({ map: text_contexto_carros})
const  mat_contexto_comunal   = new THREE.MeshStandardMaterial({ map: text_contexto_comunal})
const  mat_contexto_duplicadores   = new THREE.MeshStandardMaterial({ map: text_contexto_duplicadores})
const  mat_contexto_lafelicidad  = new THREE.MeshStandardMaterial({ map: text_contexto_lafelicidad})
const  mat_contexto_sauces  = new THREE.MeshStandardMaterial({ map: text_contexto_sauces})
const  mat_contexto_vegetacion  = new THREE.MeshStandardMaterial({ map: text_contexto_vegetacion})

const materialLinea = new THREE.LineBasicMaterial({ color: colores.contextoLineColor, linewidth: 1, transparent: true, opacity: .75 });

const mat_Zonas = new THREE.MeshNormalMaterial({
  opacity: 0.1, // Agregar opacidad
  transparent: true, // Asegurarse de que el material es transparente
  color: 0xffffff,
});

mat_Zonas.side = THREE.DoubleSide;

const mat_ZonasComunes = new THREE.MeshNormalMaterial({
    opacity: 0.1, // Agregar opacidad
  });
  
  mat_ZonasComunes.side = THREE.DoubleSide;
  
const contextoMaterial = new THREE.MeshStandardMaterial({
  color: colores.contextoFillColor,
  transparent: true,
  opacity: .95,
  polygonOffset: true,
  polygonOffsetFactor: 1,
  polygonOffsetUnits: 1
})
//Mapa


/**
 * Modelos
 */

//Escena principal
const pModX = 3
const pModY = 0
const pModZ = -5.75

const escenaPrincipal = new THREE.Group();
escenaPrincipal.position.y = 0.02
scene.add(escenaPrincipal)


  //Torre 1
  const loader = new GLTFLoader();
  loader.load(
    'modelos/TORRE 01_FL.gltf',
    function (gltf) {
        // el archivo ha sido cargado exitosamente
          gltf.scene.traverse((child) => {
              child.material = mat_Torre1                  
          })
        gltf.scene.scale.set(0.05, 0.05, 0.05)  
        scene.add(gltf.scene);
    },
  );

  loader.load(
    'modelos/TORRE 01_P1_FL.gltf',
    function (gltf) {
        // el archivo ha sido cargado exitosamente
          gltf.scene.traverse((child) => {
              child.material = mat_Torre1_p1                  
          })
        gltf.scene.scale.set(0.05, 0.05, 0.05)  
        scene.add(gltf.scene);
    },
  );
  loader.load(
    'modelos/TORRE 01_PISOS Y CUARTOS CUBIERTA_FL.gltf',
    function (gltf) {
        // el archivo ha sido cargado exitosamente
          gltf.scene.traverse((child) => {
              child.material = mat_Torre1_cubierta                  
          })
        gltf.scene.scale.set(0.05, 0.05, 0.05)  
        scene.add(gltf.scene);
    },
  );
  loader.load(
    'modelos/TORRE 01_VENTANAS_FL.gltf',
    function (gltf) {
        // el archivo ha sido cargado exitosamente
          gltf.scene.traverse((child) => {
              child.material = mat_Torre1_ventanas                  
          })
        gltf.scene.scale.set(0.05, 0.05, 0.05)  
        scene.add(gltf.scene);
    },
  );
  loader.load(
    'modelos/TORRE 01_BALCONES_MUROS_FL.gltf',
    function (gltf) {
        // el archivo ha sido cargado exitosamente
          gltf.scene.traverse((child) => {
              child.material = mat_Torre1_balconesMuros                 
          })
        gltf.scene.scale.set(0.05, 0.05, 0.05)  
        scene.add(gltf.scene);
    },
  );
  loader.load(
    'modelos/TORRE 01_BALCONES_BARANDAS_FL.gltf',
    function (gltf) {
        // el archivo ha sido cargado exitosamente
          gltf.scene.traverse((child) => {
              child.material = mat_BarandasBalcones                 
          })
        gltf.scene.scale.set(0.05, 0.05, 0.05)  
        scene.add(gltf.scene);
    },
  );
  ////Torre 2
  loader.load(
    'modelos/TORRE 02_FL.gltf',
    function (gltf) {
        // el archivo ha sido cargado exitosamente
          gltf.scene.traverse((child) => {
              child.material = mat_Torre2                  
          })
        gltf.scene.scale.set(0.05, 0.05, 0.05)  
        scene.add(gltf.scene);
    },
  );

  loader.load(
    'modelos/TORRE 02_P1_FL.gltf',
    function (gltf) {
        // el archivo ha sido cargado exitosamente
          gltf.scene.traverse((child) => {
              child.material = mat_Torre2_p1                  
          })
        gltf.scene.scale.set(0.05, 0.05, 0.05)  
        scene.add(gltf.scene);
    },
  );
  loader.load(
    'modelos/TORRE 02_PISOS Y CUARTOS CUBIERTA_FL.gltf',
    function (gltf) {
        // el archivo ha sido cargado exitosamente
          gltf.scene.traverse((child) => {
              child.material = mat_Torre2_cubierta                  
          })
        gltf.scene.scale.set(0.05, 0.05, 0.05)  
        scene.add(gltf.scene);
    },
  );
  loader.load(
    'modelos/TORRE 02_VENTANAS_FL.gltf',
    function (gltf) {
        // el archivo ha sido cargado exitosamente
          gltf.scene.traverse((child) => {
              child.material = mat_Torre2_ventanas                  
          })
        gltf.scene.scale.set(0.05, 0.05, 0.05)  
        scene.add(gltf.scene);
    },
  );
  loader.load(
    'modelos/TORRE 02_BALCONES_MUROS_FL.gltf',
    function (gltf) {
        // el archivo ha sido cargado exitosamente
          gltf.scene.traverse((child) => {
              child.material = mat_Torre2_balconesMuros                 
          })
        gltf.scene.scale.set(0.05, 0.05, 0.05)  
        scene.add(gltf.scene);
    },
  );
  loader.load(
    'modelos/TORRE 02_BALCONES_BARANDAS_FL.gltf',
    function (gltf) {
        // el archivo ha sido cargado exitosamente
          gltf.scene.traverse((child) => {
              child.material = mat_BarandasBalcones2                 
          })
        gltf.scene.scale.set(0.05, 0.05, 0.05)  
        scene.add(gltf.scene);
    },
  );
  /////contexto
  loader.load(
    'modelos/CARROS_FL.gltf',
    function (gltf) {
        // el archivo ha sido cargado exitosamente
          gltf.scene.traverse((child) => {
              child.material = mat_contexto_carros                
          })
        gltf.scene.scale.set(0.05, 0.05, 0.05)  
        scene.add(gltf.scene);
    },
  );
  loader.load(
    'modelos/COMUNAL_FL.gltf',
    function (gltf) {
        // el archivo ha sido cargado exitosamente
          gltf.scene.traverse((child) => {
              child.material = mat_contexto_comunal                 
          })
        gltf.scene.scale.set(0.05, 0.05, 0.05)  
        scene.add(gltf.scene);
    },
  );
  loader.load(
    'modelos/DUPLICADORES_FL.gltf',
    function (gltf) {
        // el archivo ha sido cargado exitosamente
          gltf.scene.traverse((child) => {
              child.material = mat_contexto_duplicadores               
          })
        gltf.scene.scale.set(0.05, 0.05, 0.05)  
        scene.add(gltf.scene);
    },
  );
  loader.load(
    'modelos/URBANISMO LA FELICIDAD_FL.gltf',
    function (gltf) {
        // el archivo ha sido cargado exitosamente
          gltf.scene.traverse((child) => {
              child.material = mat_contexto_lafelicidad                 
          })
        gltf.scene.scale.set(0.05, 0.05, 0.05)  
        scene.add(gltf.scene);
    },
  );
  loader.load(
    'modelos/URBANISMO SAUCES_FL.gltf',
    function (gltf) {
        // el archivo ha sido cargado exitosamente
          gltf.scene.traverse((child) => {
              child.material = mat_contexto_sauces                 
          })
        gltf.scene.scale.set(0.05, 0.05, 0.05)  
        scene.add(gltf.scene);
    },
  );
  loader.load(
    'modelos/VEGETACION LA FELICIDAD_FL.gltf',
    function (gltf) {
        // el archivo ha sido cargado exitosamente
          gltf.scene.traverse((child) => {
              child.material = mat_contexto_vegetacion                 
          })
        gltf.scene.scale.set(0.05, 0.05, 0.05)  
        scene.add(gltf.scene);
    },
  );
  const contexto = new THREE.Group();
  scene.add(contexto)
  
  loader.load(
    'modelos/EDIFICIOS_VECINOS.gltf',
    function (gltf) {
        // el archivo ha sido cargado exitosamente
          gltf.scene.traverse((child) => {
              child.material = mat_vecinos              
          })
        gltf.scene.scale.set(0.05, 0.05, 0.05)  
        scene.add(gltf.scene);
        contexto.add(gltf.scene)
        //Agregar bordes
        for (let i = 0; i < gltf.scene.children.length; i++) {
            var geo = new THREE.EdgesGeometry(gltf.scene.children[i].geometry);
            var wireframe = new THREE.LineSegments(geo, materialLinea);
            gltf.scene.children[i].add(wireframe)
        }
    },
  );
  

/**
 * Lights
 */

const ambientLight = new THREE.AmbientLight(0xffffff, 1);
scene.add(ambientLight);

const directionalLight = new THREE.DirectionalLight(0xffffff, 0.1);
directionalLight.castShadow = true;
directionalLight.shadow.mapSize.set(1024, 1024);
directionalLight.shadow.camera.far = 15;
directionalLight.shadow.camera.left = -7;
directionalLight.shadow.camera.top = 7;
directionalLight.shadow.camera.right = 7;
directionalLight.shadow.camera.bottom = -7;
directionalLight.position.set(-5, 5, 0);
scene.add(directionalLight);

/**
 * Terreno
 */

const terreno = new THREE.Mesh(
    new THREE.PlaneGeometry(360, 360, 60, 60),
    mat_terreno
)
terreno.rotation.x = - Math.PI * 0.5
terreno.position.y = -1.3
mapa_terrenosFolder.add(terreno.material, 'displacementScale')
mapa_terrenosFolder.add(terreno.position, 'y')
scene.add(terreno)

/**
 * Sizes
 */

const sizes = {
    width: window.innerWidth - anchoMaqueta,
    height: window.innerHeight
}

window.addEventListener('resize', () => {
    // Update sizes
    if (!menuMaqueta.classList.contains('oculta')) {
        sizes.width = window.innerWidth - anchoMaqueta
    } else {
        sizes.width = window.innerWidth
    }
    sizes.height = window.innerHeight

    // Update camera
    camera.aspect = sizes.width / sizes.height
    camera.updateProjectionMatrix()

    // Update renderer
    renderer.setSize(sizes.width, sizes.height)
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
    //Actualizar hotspot wrapper
    //hotspotsWrapper.style.width = sizes.width + 'px'

})

/**
 * Camera
 */
// Base camera
const camera = new THREE.PerspectiveCamera(75, sizes.width / sizes.height, 1, 2500000)
//const camera = new THREE.OrthographicCamera( sizes.width / - 2, sizes.width / 2, sizes.height / 2, sizes.height / - 2, 1, 1000 );
camera.position.set(2, 2, 40)
scene.add(camera)

// Controls
const controls = new OrbitControls(camera, canvas)
controls.target.set(0, 0.75, 0)
controls.enableDamping = true
controls.maxPolarAngle = Math.PI/2;
controls.minDistance = 6
controls.maxDistance = 30

/**
 * Urbanismo Fondo
 */
const floor = new THREE.Mesh(
    new THREE.PlaneGeometry(100, 100),
    mat_urbanismo_fondo);
  floor.receiveShadow = true;
  floor.position.set(-0.2, -0.1, -0.3);
  floor.rotation.x = -Math.PI * 0.5;
  floor.rotation.z = Math.PI * 0.255;
  floor.scale.set(1.55, 1.55, 1.55) 
  scene.add(floor);  
  
/**
 * Renderer
 */
const renderer = new THREE.WebGLRenderer({
    canvas: canvas,
    antialias: true
})
renderer.shadowMap.enabled = true
renderer.shadowMap.type = THREE.PCFSoftShadowMap
renderer.setSize(sizes.width, sizes.height)
renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2))
renderer.antialias = true
renderer.setClearColor(colores.colorCielo)



//Niebla
const niebla = new THREE.Fog(colores.colorBruma, 2, 180)
scene.fog = niebla

/**
 * Hotspots
 */
const raycaster = new Raycaster()
const mouse = new THREE.Vector2()

window.addEventListener('mousemove', (event) => {
    mouse.x = event.clientX / sizes.width * 2 - 1
    mouse.y = - (event.clientY / sizes.height) * 2 + 1

})




//coloresFolder.add(mat_piso, 'map').mapa
//Bug Hotspots
var frustum = new THREE.Frustum();


/**
 * Animate
 */
 const clock = new THREE.Clock()
 let previousTime = 0
 let interseccionActual = null
 
 const tick = () => {
     const elapsedTime = clock.getElapsedTime()
     const deltaTime = elapsedTime - previousTime
     previousTime = elapsedTime
 
     // Cast a ray from the mouse and handle events
    raycaster.setFromCamera(mouse, camera) 

     // Update controls
     controls.update()
 
     //let cameraX = Math.abs(camera.position.x)
     //let cameraY = Math.abs(camera.position.y)
     //let cameraZ = Math.abs(camera.position.z)
 
     frustum.setFromProjectionMatrix(new THREE.Matrix4().multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse));

     // Render
     renderer.render(scene, camera)
 
     //console.log(camera.position)
     // Call tick again on the next frame
     window.requestAnimationFrame(tick)
 }
 
 tick()